import authHeader from '@/backend/auth/auth-header'
import { useAuthAxios } from '@/backend/utils'


const api = useAuthAxios({
  baseURL: '/distributor/',
})

export async function getGroups(params = {}) {
  const response = await api.get('groups', {
    params,
    headers: authHeader(),
  })
  return response.data
}

export async function upsertGroup(payload) {
  const response = await api.post('groups', payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function replaceGroup(groupId, payload) {
  const response = await api.put(`groups/${encodeURIComponent(groupId)}`, payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function deleteGroup(groupId) {
  const response = await api.delete(`groups/${encodeURIComponent(groupId)}`, {
    headers: authHeader(),
  })
  return response.data
}

export async function getBindings(params = {}) {
  const response = await api.get('bindings', {
    params,
    headers: authHeader(),
  })
  return response.data
}

export async function upsertBinding(payload) {
  const response = await api.post('bindings', payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function replaceBinding(bindingId, payload) {
  const response = await api.put(`bindings/${encodeURIComponent(bindingId)}`, payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function deleteBinding(bindingId) {
  const response = await api.delete(`bindings/${encodeURIComponent(bindingId)}`, {
    headers: authHeader(),
  })
  return response.data
}

export async function getAssignments(params = {}) {
  const response = await api.get('assignments', {
    params,
    headers: authHeader(),
  })
  return response.data
}

export async function getOverview(params = {}) {
  const response = await api.get('overview', {
    params,
    headers: authHeader(),
  })
  return response.data
}

export async function getProblems(params = {}) {
  const response = await api.get('problems', {
    params,
    headers: authHeader(),
  })
  return response.data
}

export async function getFailures(params = {}) {
  const response = await api.get('failures', {
    params,
    headers: authHeader(),
  })
  return response.data
}

export async function getReplacements(params = {}) {
  const response = await api.get('replacements', {
    params,
    headers: authHeader(),
  })
  return response.data
}

export async function retryFailure(failureKey, payload) {
  const response = await api.post(
    `failures/${encodeURIComponent(failureKey)}/retry`,
    payload,
    { headers: authHeader() },
  )
  return response.data
}

export async function getAccounts(params = {}) {
  const response = await api.get('accounts', {
    params,
    headers: authHeader(),
  })
  return response.data
}

export async function updateAccount(accountId, payload) {
  const response = await api.patch(`accounts/${accountId}`, payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function probeToken(token, contactId = null) {
  const response = await api.post(
    'accounts/probe-token',
    { token, contact_id: contactId },
    { headers: authHeader() },
  )
  return response.data
}

export async function probeAccount(contactId) {
  const response = await api.post(
    'accounts/probe-account',
    { contact_id: contactId },
    { headers: authHeader() },
  )
  return response.data
}

export async function searchCities(q, limit = 20) {
  const response = await api.get('cities/search', {
    params: { q, limit },
    headers: authHeader(),
  })
  return response.data
}

export async function getCitiesByIds(cityIds) {
  const response = await api.post('cities/by-ids', {
    city_ids: [...new Set(cityIds.map(Number).filter((cityId) => Number.isFinite(cityId) && cityId > 0))],
  }, {
    headers: authHeader(),
  })
  return response.data
}

export async function searchRegions(q = '', limit = 200, country = '') {
  const response = await api.get('regions/search', {
    params: { q, limit, ...(country ? { country } : {}) },
    headers: authHeader(),
  })
  return response.data
}
